import auth from "@/store/auth";
import external from "@/gavnoCode/external";
import errorHandlerExternal from "@/plugins/errorHandlerExternal";
import router from "@/router";

export default {
    /**
     * Получение массива доступов
     * @constructor
     */
    getAccess: () => {
        auth.mutations.loadingStatus(auth.state, true)
        external.universalRequest({
            externalType: 'ms',
            msUrl: 'accessnp/CotrollerRole/getWebObjectsByUserID',
            urlType: '',
            method: 'GET',
        }).then((res) => {
            for (let i = 0; i < res.length; i++) {
                res[i]['show'] = false;
            }
            auth.mutations.saveAccessArray(auth.state, res);
            auth.mutations.loadingStatus(auth.state, false);
        }).catch(res => {
            errorHandlerExternal(res, router, 'checkAccess');
            auth.mutations.loadingStatus(auth.state, false)
        })
    },
}
